(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flaunt-catalog-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('flaunt-catalog-story')) return;

  class FlauntCatalogStory extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      try { this.config = JSON.parse(this.querySelector('[data-fcs-config]').textContent); }
      catch (_) { return; }
      this.chapters = [...this.querySelectorAll('[data-fcs-chapter]')];
      this.details = this.chapters.map(chapter => chapter.querySelector('[data-fcs-details]'));
      this.copyContents = this.details.map(details => details?.querySelector('.fcs-details-inner'));
      this.scenes = [...this.querySelectorAll('[data-fcs-scene]')];
      this.states = this.config.chapters || [];
      this.stage = this.querySelector('[data-fcs-stage]');
      this.initialPoster = this.querySelector('[data-fcs-initial-poster]');
      this.players = [...this.querySelectorAll('[data-fcs-player]')];
      this.markers = [...this.querySelectorAll('[data-fcs-go]')];
      if (!this.chapters.length || this.states.length !== this.chapters.length || this.scenes.length !== this.chapters.length || this.details.some(details => !details) || this.players.length !== 2 || !this.stage) return;
      this.controller = new AbortController();
      this.current = this.target = 0;
      this.active = null;
      this.front = this.players[0];
      this.serial = (this.serial || 0) + 1;
      this.fastJump = false;
      this.lastDirection = 1;
      this.visible = false;
      this.introDone = false;
      this.wheelConsumed = false;
      this.wheelTotal = 0;
      this.touch = null;
      this.status = this.querySelector('[data-fcs-status]');
      this.previous = this.querySelector('[data-fcs-previous]');
      this.next = this.querySelector('[data-fcs-next]');
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.copyTarget = null;
      this.copySequence = 0;
      this.layoutIndex = -1;
      const listen = (node, name, handler, options = {}) => node.addEventListener(name, handler, { ...options, signal: this.controller.signal });
      listen(window, 'wheel', event => this.onWheel(event), { passive: false });
      listen(this, 'touchstart', event => this.onTouchStart(event), { passive: true });
      listen(this, 'touchmove', event => this.onTouchMove(event), { passive: false });
      listen(this, 'touchend', event => this.onTouchEnd(event), { passive: true });
      listen(this, 'touchcancel', () => { this.touch = null; }, { passive: true });
      listen(window, 'keydown', event => this.onKey(event));
      listen(this, 'click', event => {
        const marker = event.target.closest('[data-fcs-go]');
        if (marker && this.contains(marker)) this.goTo(Number(marker.dataset.fcsGo));
        if (event.target.closest('[data-fcs-previous]')) this.goTo(this.current - 1);
        if (event.target.closest('[data-fcs-next]')) this.goTo(this.current + 1);
      });
      listen(document, 'shopify:block:select', event => {
        const index = this.chapters.findIndex(chapter => chapter.dataset.fcsBlock === event.detail?.blockId || chapter.contains(event.target));
        if (index >= 0) {
          this.stage.scrollIntoView({ behavior: 'instant', block: 'start' });
          this.goTo(index);
        }
      });
      listen(document, 'visibilitychange', () => {
        if (document.hidden) { this.touch = null; this.resetWheel(); }
        this.syncPlayback();
      });
      listen(document, 'flaunt:route-ready', () => this.syncPlayback());
      listen(this.mobile, 'change', () => {
        this.touch = null;
        if (this.active) this.fallback(this.active);
        else this.preloadNext();
      });
      this.querySelectorAll('[data-fcs-logo]').forEach(image => {
        const update = () => {
          const valid = image.naturalWidth > 0 && image.naturalHeight > 0;
          image.hidden = !valid;
          image.closest('.fcs-brand').classList.toggle('has-logo', valid);
        };
        listen(image, 'load', update);
        listen(image, 'error', update);
        if (image.complete) update();
      });
      this.querySelectorAll('[data-fcs-poster]').forEach(image => {
        const update = () => { image.style.visibility = image.naturalWidth ? '' : 'hidden'; };
        listen(image, 'load', update);
        listen(image, 'error', update);
        if (image.complete) update();
      });
      if (this.initialPoster) this.initialPoster.hidden = !this.config.initial_poster || !this.videoSource(0, 1);
      this.classList.add('is-enhanced');
      this.measureCopy();
      this.copyObserver = new ResizeObserver(() => {
        cancelAnimationFrame(this.measureCopyFrame);
        this.measureCopyFrame = requestAnimationFrame(() => this.measureCopy());
      });
      this.copyContents.forEach(content => this.copyObserver.observe(content));
      this.present(0, false, true);
      if (this.videoSource(0, 1)) {
        this.presentCopy(-1, false);
        this.copyTarget = null;
      }
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (!this.visible) this.touch = null;
        this.syncPlayback();
      }, { threshold: 0.1 });
      this.observer.observe(this.stage);
    }

    disconnectedCallback() {
      this.serial++;
      this.controller?.abort();
      this.controller = null;
      this.loadController?.abort();
      this.observer?.disconnect();
      this.copyObserver?.disconnect();
      this.resetWheel();
      clearTimeout(this.transitionTimer);
      clearTimeout(this.watchdog);
      clearTimeout(this.copyExitTimer);
      clearTimeout(this.copyRevealTimer);
      this.copySequence++;
      cancelAnimationFrame(this.measureCopyFrame);
      cancelAnimationFrame(this.cutFrame);
      this.players?.forEach(video => this.release(video));
      if (this.initialPoster) this.initialPoster.hidden = true;
      this.active = null;
      this.touch = null;
      this.classList.remove('is-enhanced', 'is-playing', 'is-loading', 'is-cut', 'is-video-transition', 'is-mobile-video');
      this.chapters?.forEach(chapter => { chapter.classList.remove('is-copy-active', 'is-copy-expanded'); chapter.inert = false; chapter.removeAttribute('aria-hidden'); });
      this.details?.forEach(details => { details.inert = false; details.removeAttribute('aria-hidden'); });
      this.markers?.forEach(marker => marker.setAttribute('aria-expanded', 'true'));
    }

    resetWheel() {
      clearTimeout(this.wheelTimer);
      this.wheelTotal = 0;
      this.wheelConsumed = false;
    }

    release(video) {
      video.pause();
      video.hidden = true;
      video.removeAttribute('src');
      video.preload = 'none';
      video.load();
    }

    canPlay() { return this.visible && !document.hidden && !document.documentElement.classList.contains('flaunt-route-entering'); }

    usable(event) {
      if (!this.canPlay()) return false;
      const rect = this.stage.getBoundingClientRect();
      if (rect.bottom <= innerHeight * 0.4 || rect.top >= innerHeight * 0.55) return false;
      const target = event?.target instanceof Element ? event.target : null;
      if (target?.closest('input, textarea, select, [contenteditable], dialog, [role="dialog"], [role="menu"], #header-group, footer')) return false;
      const overlays = document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], [role="menu"], #header-component [aria-expanded="true"]');
      return ![...overlays].some(node => !node.closest('[hidden], [inert], [aria-hidden="true"]') && node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
    }

    exits(direction) {
      return !this.active && this.current === this.target && ((direction < 0 && this.current === 0) || (direction > 0 && this.current === this.states.length - 1));
    }

    onWheel(event) {
      if (event.ctrlKey || event.metaKey || !event.deltaY || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
      const direction = Math.sign(event.deltaY);
      if (!this.usable(event)) { this.resetWheel(); return; }
      if (!this.wheelConsumed && this.exits(direction)) return;
      if (event.cancelable) event.preventDefault();
      clearTimeout(this.wheelTimer);
      this.wheelTimer = setTimeout(() => this.resetWheel(), 320);
      if (this.wheelConsumed) return;
      const scale = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? innerHeight : 1;
      this.wheelTotal += event.deltaY * scale;
      if (Math.abs(this.wheelTotal) < 35) return;
      this.wheelConsumed = true;
      this.step(Math.sign(this.wheelTotal));
    }

    onTouchStart(event) {
      this.touch = null;
      if (event.touches.length !== 1 || !this.usable(event)) return;
      const point = event.touches[0];
      this.touch = { id: point.identifier, x: point.clientX, y: point.clientY, dy: 0, claimed: false, native: false };
    }

    onTouchMove(event) {
      const gesture = this.touch;
      if (!gesture || gesture.native) return;
      if (event.touches.length !== 1 || !this.usable(event)) { this.touch = null; return; }
      const point = [...event.touches].find(touch => touch.identifier === gesture.id);
      if (!point) { this.touch = null; return; }
      const dx = point.clientX - gesture.x;
      gesture.dy = gesture.y - point.clientY;
      if (!gesture.claimed) {
        if (Math.max(Math.abs(dx), Math.abs(gesture.dy)) < 6) return;
        if (Math.abs(dx) >= Math.abs(gesture.dy) || this.exits(Math.sign(gesture.dy))) { gesture.native = true; return; }
        gesture.claimed = true;
      }
      if (event.cancelable) event.preventDefault();
    }

    onTouchEnd(event) {
      const gesture = this.touch;
      if (!gesture || [...event.touches].some(touch => touch.identifier === gesture.id)) return;
      this.touch = null;
      if (!gesture.native && gesture.claimed && Math.abs(gesture.dy) >= 40 && this.usable(event)) this.step(Math.sign(gesture.dy));
    }

    onKey(event) {
      if (event.altKey || event.ctrlKey || event.metaKey || !this.usable(event)) return;
      if (document.activeElement !== document.body && !this.contains(document.activeElement)) return;
      const direction = ['ArrowDown', 'ArrowRight', 'PageDown'].includes(event.key) ? 1 : ['ArrowUp', 'ArrowLeft', 'PageUp'].includes(event.key) ? -1 : 0;
      if (!direction || this.exits(direction)) return;
      event.preventDefault();
      if (!event.repeat) this.step(direction);
    }

    step(direction) {
      this.fastJump = false;
      this.target = this.active ? (direction === this.active.direction ? this.active.to : this.active.from) : Math.max(0, Math.min(this.states.length - 1, this.current + direction));
      this.updateRate();
      this.pump();
    }

    goTo(index) {
      if (!Number.isInteger(index) || !this.states[index]) return;
      this.touch = null;
      this.target = index;
      this.fastJump = Math.abs(index - this.current) > 1;
      this.updateRate();
      this.pump();
    }

    updateRate() {
      if (this.active?.ready) this.front.playbackRate = this.fastJump && this.active.to !== this.target ? 2.5 : this.active.intro ? 1 : 1.5;
    }

    videoSource(index, direction) {
      return this.clipSource(this.states[index], direction);
    }

    clipSource(clip, direction, prefix = 'transition_') {
      if (!clip) return '';
      const suffix = direction > 0 ? 'forward' : 'reverse';
      return (this.mobile.matches && clip['mobile_' + suffix]) || clip[prefix + suffix] || '';
    }

    jumpClip(from, to) {
      if (Math.abs(to - from) < 2) return null;
      const first = Math.min(from, to);
      const last = Math.max(from, to);
      const clip = this.config.jumps?.[`${first}:${last}`];
      if (!clip || Number(clip.from) !== first || Number(clip.to) !== last) return null;
      const url = this.clipSource(clip, Math.sign(to - from), '');
      return typeof url === 'string' && url.trim() ? clip : null;
    }

    syncPlayback() {
      if (!this.canPlay()) { this.front?.pause(); return; }
      if (!this.introDone) {
        this.introDone = true;
        if (this.videoSource(0, 1)) { this.transition(0, 0, true); return; }
      }
      if (this.active?.ready && !this.active.fallback) this.play(this.active);
      else this.pump();
    }

    pump() {
      if (!this.canPlay() || this.active) return;
      if (this.current === this.target) { this.preloadNext(); return; }
      const jump = this.jumpClip(this.current, this.target);
      if (jump) this.transition(this.current, this.target, false, jump);
      else this.transition(this.current, this.current + Math.sign(this.target - this.current));
    }

    preloadNext(index = this.current, direction = this.lastDirection) {
      if (!this.canPlay()) return;
      if (!this.states[index + direction]) direction *= -1;
      if (!this.states[index + direction]) return;
      const url = this.videoSource(Math.max(index, index + direction), direction);
      const next = this.players.find(video => video !== this.front);
      if (!url || !next || next.getAttribute('src') === url) return;
      next.pause();
      next.hidden = true;
      next.muted = true;
      next.defaultMuted = true;
      next.playsInline = true;
      next.preload = 'auto';
      next.src = url;
      next.load();
    }

    moveFocus(index) {
      const focused = document.activeElement;
      if (this.details.some((details, position) => position !== index && details.contains(focused))) this.markers[index]?.focus({ preventScroll: true });
    }

    measureCopy() {
      const height = Math.ceil(Math.max(...this.copyContents.map(content => content.getBoundingClientRect().height)));
      if (height > 0 && height !== this.copyHeight) {
        this.copyHeight = height;
        this.style.setProperty('--fcs-details-height', `${height}px`);
      }
    }

    layoutCopy(index) {
      this.layoutIndex = index;
      this.chapters.forEach((chapter, position) => {
        const selected = position === index;
        chapter.classList.toggle('is-copy-expanded', selected);
        this.markers[position]?.setAttribute('aria-expanded', String(selected));
        if (selected) this.markers[position]?.setAttribute('aria-current', 'step');
        else this.markers[position]?.removeAttribute('aria-current');
      });
    }

    requestCopy(index, announce = true, immediate = false) {
      if (this.copyTarget === index) return;
      clearTimeout(this.copyExitTimer);
      clearTimeout(this.copyRevealTimer);
      const sequence = ++this.copySequence;
      this.copyTarget = index;
      this.moveFocus(index);
      if (immediate) {
        this.layoutCopy(index);
        this.presentCopy(index, announce);
        return;
      }
      const hasOutgoing = this.copyIndex >= 0;
      this.presentCopy(-1, false);
      const rearrange = () => {
        if (sequence !== this.copySequence || !this.controller) return;
        const changesLayout = this.layoutIndex !== index;
        this.layoutCopy(index);
        this.copyRevealTimer = setTimeout(() => {
          if (sequence === this.copySequence && this.controller) this.presentCopy(index, announce);
        }, changesLayout && !this.reduced.matches ? 180 : 0);
      };
      if (hasOutgoing) this.copyExitTimer = setTimeout(rearrange, 180);
      else rearrange();
    }

    presentCopy(index, announce = true) {
      this.copyIndex = index;
      this.chapters.forEach((chapter, position) => {
        const selected = position === index;
        chapter.classList.toggle('is-copy-active', selected);
        this.details[position].inert = !selected;
        this.details[position].setAttribute('aria-hidden', String(!selected));
      });
      if (announce && this.status && this.states[index]) this.status.textContent = this.states[index].status;
    }

    present(index, announce = true, immediateCopy = false) {
      this.moveFocus(index);
      this.chapters.forEach((chapter, position) => {
        chapter.classList.toggle('is-active', position === index);
        this.scenes[position].classList.toggle('is-active', position === index);
      });
      this.requestCopy(index, announce, immediateCopy);
      const focused = document.activeElement;
      if ((focused === this.previous && index === 0) || (focused === this.next && index === this.states.length - 1)) this.markers[index]?.focus({ preventScroll: true });
      if (this.previous) this.previous.disabled = index === 0;
      if (this.next) this.next.disabled = index === this.states.length - 1;
    }

    async transition(from, to, intro = false, jump = null) {
      this.loadController?.abort();
      clearTimeout(this.transitionTimer);
      clearTimeout(this.watchdog);
      const active = this.active = { from, to, intro, direction: intro ? 1 : Math.sign(to - from), serial: ++this.serial, ready: false, fallback: false };
      this.lastDirection = active.direction;
      this.classList.add('has-navigated');
      this.moveFocus(to);
      const clipIndex = intro ? 0 : Math.max(from, to);
      const clip = jump || this.states[clipIndex];
      const url = this.clipSource(clip, active.direction, jump ? '' : 'transition_');
      if (!url) { this.fallback(active); return; }
      this.requestCopy(to);
      this.classList.toggle('is-mobile-video', this.mobile.matches && Boolean(clip['mobile_' + (active.direction > 0 ? 'forward' : 'reverse')]));
      this.classList.add('is-loading', 'is-video-transition');
      const next = this.players.find(video => video !== this.front);
      const signal = (this.loadController = new AbortController()).signal;
      this.watchdog = setTimeout(() => this.fallback(active), 35000);
      try {
        next.pause();
        next.muted = true;
        next.defaultMuted = true;
        next.playsInline = true;
        next.preload = 'auto';
        if (next.getAttribute('src') !== url) { next.src = url; next.load(); }
        await this.waitReady(next, signal);
        if (this.active !== active || signal.aborted) return;
        this.front.pause();
        this.front.hidden = true;
        this.front = next;
        if (next.currentTime !== 0) next.currentTime = 0;
        next.hidden = false;
        active.ready = true;
        this.updateRate();
        this.classList.remove('is-loading');
        next.addEventListener('ended', () => this.finish(active, true), { once: true, signal });
        next.addEventListener('error', () => this.fallback(active), { once: true, signal });
        if (this.canPlay()) this.play(active);
        this.preloadNext(active.to, active.direction);
      } catch (error) {
        if (error.name !== 'AbortError' && this.active === active) this.fallback(active);
      }
    }

    waitReady(video, signal) {
      return new Promise((resolve, reject) => {
        if (signal.aborted) { reject(new DOMException('Aborted', 'AbortError')); return; }
        if (video.readyState >= 2) { resolve(); return; }
        const cleanup = () => {
          clearTimeout(timer);
          video.removeEventListener('loadeddata', ready);
          video.removeEventListener('canplay', ready);
          video.removeEventListener('error', failed);
          signal.removeEventListener('abort', aborted);
        };
        const ready = () => { if (video.readyState >= 2) { cleanup(); resolve(); } };
        const failed = () => { cleanup(); reject(new Error('Video unavailable')); };
        const aborted = () => { cleanup(); reject(new DOMException('Aborted', 'AbortError')); };
        const timer = setTimeout(failed, 12000);
        video.addEventListener('loadeddata', ready);
        video.addEventListener('canplay', ready);
        video.addEventListener('error', failed);
        signal.addEventListener('abort', aborted, { once: true });
      });
    }

    async play(active) {
      if (this.active !== active || active.starting || active.fallback || !this.canPlay()) return;
      active.starting = true;
      try {
        await this.front.play();
        if (this.active !== active) return;
        if (!this.canPlay()) { this.front.pause(); return; }
        this.classList.add('is-playing');
      } catch (_) {
        if (this.active === active) this.fallback(active);
      } finally { active.starting = false; }
    }

    fallback(active) {
      if (this.active !== active || active.fallback) return;
      active.fallback = true;
      this.loadController?.abort();
      clearTimeout(this.watchdog);
      this.players.forEach(video => { video.pause(); video.hidden = true; });
      if (this.initialPoster) this.initialPoster.hidden = true;
      this.classList.remove('is-loading', 'is-playing', 'is-video-transition', 'is-mobile-video');
      this.present(active.to);
      const duration = this.reduced.matches ? 0 : this.fastJump && active.to !== this.target ? 360 : 900;
      this.transitionTimer = setTimeout(() => this.finish(active), duration);
    }

    finish(active, cut = false) {
      if (this.active !== active) return;
      clearTimeout(this.watchdog);
      clearTimeout(this.transitionTimer);
      this.loadController?.abort();
      this.front.pause();
      if (cut) this.classList.add('is-cut');
      this.current = active.to;
      if (this.initialPoster) this.initialPoster.hidden = true;
      this.present(this.current, !active.fallback);
      this.players.forEach(video => { video.hidden = true; });
      this.classList.remove('is-loading', 'is-playing', 'is-video-transition', 'is-mobile-video');
      this.active = null;
      if (this.current === this.target) this.fastJump = false;
      if (cut) {
        cancelAnimationFrame(this.cutFrame);
        this.cutFrame = requestAnimationFrame(() => {
          this.cutFrame = requestAnimationFrame(() => {
            this.classList.remove('is-cut');
            this.pump();
          });
        });
      } else this.pump();
    }
  }

  customElements.define('flaunt-catalog-story', FlauntCatalogStory);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flaunt-scroll-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('flaunt-scroll-story')) return;

  class FlauntScrollStory extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      try { this.config = JSON.parse(this.querySelector('[data-story-config]').textContent); }
      catch (_) { return; }
      this.states = this.config.states || [];
      this.players = [...this.querySelectorAll('video[data-player]')];
      this.triggers = [...this.querySelectorAll('.fss-trigger[data-state]')];
      this.stage = this.querySelector('.fss-stage');
      if (this.states.length !== 6 || this.players.length !== 2 || !this.stage) return;
      this.controller = new AbortController();
      this.poster = this.querySelector('[data-poster]');
      this.logo = this.querySelector('[data-logo]');
      this.styleLabels = [...this.querySelectorAll('[data-mobile-style-label]')];
      this.status = this.querySelector('[data-status]');
      const restoreChapter = window.FlauntRoute?.restoreChapter;
      this.restoringRoute = Number.isInteger(restoreChapter) && restoreChapter >= 0 && restoreChapter < this.states.length;
      this.current = this.target = this.restoringRoute ? restoreChapter : 0;
      if (this.restoringRoute) delete window.FlauntRoute.restoreChapter;
      this.fastTarget = null;
      this.markerTarget = null;
      this.failedJumpPairs = new Set();
      this.players.forEach(video => { video.playbackRate = 1; });
      this.copyIndex = null;
      this.active = null;
      this.front = this.players[0];
      this.serial = (this.serial || 0) + 1;
      this.visible = false;
      this.variantConfig = null;
      this.mobileQuery = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const listen = (node, name, fn, options = {}) => node.addEventListener(name, fn, { ...options, signal: this.controller.signal });
      listen(window, 'scroll', () => this.queueScroll(), { passive: true, capture: true });
      listen(window, 'resize', () => { this.selectVariant(); this.syncPlayback(); }, { passive: true });
      listen(this.mobileQuery, 'change', () => this.selectVariant());
      listen(document, 'visibilitychange', () => {
        if (document.hidden) this.clearSwipe();
        this.syncPlayback();
      });
      listen(document, 'flaunt:route-ready', () => this.syncPlayback());
      listen(this, 'touchstart', event => this.beginSwipe(event), { passive: true });
      listen(this, 'touchmove', event => this.moveSwipe(event), { passive: false });
      listen(this, 'touchend', event => this.endSwipe(event), { passive: true });
      listen(this, 'touchcancel', () => this.clearSwipe(), { passive: true });
      ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(name => {
        listen(window, name, event => {
          if (event.isTrusted && (name === 'wheel' || (name === 'keydown' && ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key) && !event.target.closest('button, a, input, textarea, select, [contenteditable]')))) {
            this.markerTarget = null;
            this.setFastTarget(null);
          }
          if (event.isTrusted && this.active?.blocked) this.startPlayback(this.active, true);
        }, { passive: true, capture: true });
      });
      listen(window, 'touchmove', event => {
        if (event.isTrusted) {
          this.markerTarget = null;
          this.setFastTarget(null);
        }
      }, { passive: true, capture: true });
      listen(this, 'click', event => {
        const go = event.target.closest('[data-go]');
        if (go && this.contains(go)) this.goTo(Number(go.dataset.go));
      });
      listen(document, 'shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const block = event.target.closest('[data-story-state]');
        if (block) this.goTo(Number(block.dataset.storyState));
      });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.syncPlayback();
      }, { threshold: 0.01 });
      this.observer.observe(this.stage);
      this.classList.add('is-enhanced');
      this.classList.remove('is-static', 'is-playing', 'is-loading');
      this.selectVariant();
      if (this.restoringRoute) this.restoreRouteChapter();
      else this.queueScroll();
    }

    disconnectedCallback() {
      this.clearSwipe();
      this.serial++;
      this.loadController?.abort();
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.scrollRequest);
      this.scrollRequest = 0;
      cancelAnimationFrame(this.routeRestoreRequest);
      this.stopFrameLoop();
      this.players?.forEach(video => this.release(video));
      this.active = null;
      this.markerTarget = null;
    }

    selectVariant() {
      const mobile = this.config.mobile;
      const isMobile = this.mobileQuery.matches && mobile?.enabled === true && Array.isArray(mobile.states) && mobile.states.length === 6;
      const variant = isMobile ? mobile : this.config;
      if (this.variantConfig === variant) return;
      this.clearSwipe();
      const current = this.current;
      const target = this.target;
      this.serial++;
      this.loadController?.abort();
      cancelAnimationFrame(this.scrollRequest);
      this.scrollRequest = 0;
      this.stopFrameLoop();
      this.active = null;
      this.players.forEach(video => { this.release(video); video.hidden = true; });
      this.front = this.players[0];
      this.variantConfig = variant;
      this.failedJumpPairs.clear();
      this.isMobileStory = isMobile;
      this.states = variant.states;
      this.fps = Number(variant.fps) || 60;
      this.frameStep = Math.max(1, Number(variant.frameStep) || 1);
      this.playbackFps = Number(variant.playbackFps) || this.fps / this.frameStep;
      this.edgeOffset = Number.isFinite(Number(variant.edgeOffset)) ? Number(variant.edgeOffset) : 1;
      this.classList.toggle('is-mobile-story', isMobile);
      this.classList.remove('is-playing', 'is-loading', 'is-preview-video');
      if (this.poster) {
        this.poster.width = Number(variant.width) || (isMobile ? 432 : 1920);
        this.poster.height = Number(variant.height) || (isMobile ? 768 : 1080);
        if (this.states[current].poster) this.poster.src = this.states[current].poster;
        this.poster.hidden = false;
      }
      this.target = target;
      this.dataset.target = target;
      this.showState(current, true);
      this.pump();
    }

    release(video) {
      video.pause();
      video.playbackRate = 1;
      video.removeAttribute('src');
      video.preload = 'none';
      video.load();
    }

    swipeEnabled() {
      return this.mobileQuery.matches && (this.isMobileStory || this.config.singleSwipeNavigation === true);
    }

    stagePinned() {
      const rect = this.stage.getBoundingClientRect();
      const top = parseFloat(getComputedStyle(this.stage).top) || 0;
      return Math.abs(rect.top - top) <= 4 && rect.bottom > window.innerHeight * 0.5;
    }

    stageAtFooter() {
      if (this.active || this.current !== this.target || this.current !== this.states.length - 1) return false;
      const rect = this.stage.getBoundingClientRect();
      const top = parseFloat(getComputedStyle(this.stage).top) || 0;
      return rect.top < top - 4 && rect.bottom > window.innerHeight * 0.5;
    }

    clearSwipe() {
      this.swipe = null;
      this.swipeGuard = false;
      clearTimeout(this.swipeTimer);
      cancelAnimationFrame(this.swipeAlignRequest);
      this.swipeAlignRequest = 0;
    }

    beginSwipe(event) {
      this.clearSwipe();
      if (!this.swipeEnabled() || event.touches.length !== 1 || !this.stage.contains(event.target) || (!this.stagePinned() && !this.stageAtFooter())) return;
      if (event.target.closest('input, textarea, select, [contenteditable]')) return;
      const touch = event.touches[0];
      this.swipe = { id: touch.identifier, x: touch.clientX, y: touch.clientY, claimed: false, consumed: false };
    }

    moveSwipe(event) {
      const swipe = this.swipe;
      if (!swipe || swipe.native) return;
      if (!this.swipeEnabled() || event.touches.length !== 1) { this.clearSwipe(); return; }
      const touch = [...event.touches].find(item => item.identifier === swipe.id);
      if (!touch) { this.clearSwipe(); return; }
      const dx = touch.clientX - swipe.x;
      const dy = swipe.y - touch.clientY;
      if (!swipe.claimed) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 6) return;
        if (Math.abs(dx) >= Math.abs(dy)) { swipe.native = true; return; }
        const direction = Math.sign(dy);
        if (!this.stagePinned() && !(direction < 0 && this.stageAtFooter())) { swipe.native = true; return; }
        const settled = !this.active && this.current === this.target;
        if (settled && ((direction < 0 && this.current === 0) || (direction > 0 && this.current === this.states.length - 1))) {
          swipe.native = true;
          return;
        }
        swipe.claimed = true;
        this.swipeGuard = true;
        cancelAnimationFrame(this.scrollRequest);
        this.scrollRequest = 0;
        this.markerTarget = null;
        this.setFastTarget(null);
        this.target = this.active ? this.active.to : this.current;
        this.dataset.target = this.target;
        this.highlightChapter(this.target);
      }
      if (event.cancelable) event.preventDefault();
      if (swipe.consumed || Math.abs(dy) < 40) return;
      swipe.consumed = true;
      const direction = Math.sign(dy);
      const active = this.active;
      const index = active
        ? (direction === active.direction ? active.to : active.from)
        : Math.max(0, Math.min(this.states.length - 1, this.current + direction));
      this.setFastTarget(null);
      this.target = index;
      this.dataset.target = index;
      this.highlightChapter(index);
      this.alignSwipe(index);
      this.pump();
    }

    alignSwipe(index) {
      const trigger = this.triggers.find(item => Number(item.dataset.state) === index);
      trigger?.scrollIntoView({ behavior: 'instant', block: 'center' });
    }

    endSwipe(event) {
      const swipe = this.swipe;
      if (!swipe || [...event.touches].some(touch => touch.identifier === swipe.id)) return;
      this.swipe = null;
      if (!swipe.claimed) return;
      this.alignSwipe(this.target);
      this.swipeAlignRequest = requestAnimationFrame(() => {
        this.swipeAlignRequest = 0;
        this.alignSwipe(this.target);
        this.swipeTimer = setTimeout(() => {
          this.swipeGuard = false;
          this.queueScroll();
        }, 160);
      });
    }

    restoreRouteChapter() {
      const index = this.target;
      this.alignSwipe(index);
      this.routeRestoreRequest = requestAnimationFrame(() => {
        this.alignSwipe(index);
        this.restoringRoute = false;
        this.queueScroll();
      });
    }

    queueScroll() {
      if (this.restoringRoute || this.swipeGuard || this.scrollRequest) return;
      this.scrollRequest = requestAnimationFrame(() => {
        this.scrollRequest = 0;
        if (this.swipeGuard) return;
        let target = 0;
        const threshold = window.innerHeight * 0.5;
        for (const trigger of this.triggers) {
          if (trigger.getBoundingClientRect().top <= threshold) target = Number(trigger.dataset.state);
        }
        this.target = Math.max(0, Math.min(5, target));
        if (this.markerTarget !== null && this.target !== this.markerTarget) this.markerTarget = null;
        if (this.fastTarget !== null && this.target !== this.fastTarget) this.setFastTarget(null);
        if (this.active?.kind === 'jump' && this.target !== this.active.to) this.setCopy(-1);
        this.dataset.target = this.target;
        this.highlightChapter(this.target);
        this.pump();
      });
    }

    goTo(index) {
      if (!Number.isInteger(index) || !this.states[index]) return;
      this.clearSwipe();
      const trigger = this.triggers.find(trigger => Number(trigger.dataset.state) === index);
      if (!trigger) return;
      const fast = Math.abs(index - this.current) > 1;
      const direct = fast || this.fastTarget !== null || this.active?.kind === 'jump';
      this.markerTarget = index;
      this.setFastTarget(fast ? index : null);
      if (direct) {
        this.target = index;
        this.dataset.target = index;
        this.highlightChapter(index);
      }
      if ((fast || this.active?.kind === 'jump') && this.active?.to !== index) this.setCopy(-1);
      trigger.scrollIntoView({
        behavior: direct || this.reduced.matches ? 'instant' : 'smooth', block: 'center'
      });
      if (direct) this.pump();
    }

    setFastTarget(index) {
      if (this.fastTarget === index) return;
      this.fastTarget = index;
      const rate = index === null || this.active?.kind === 'jump' ? 1 : 3;
      this.players.forEach(video => { video.playbackRate = rate; });
    }

    canPlay() { return this.visible && !document.hidden && !document.documentElement.classList.contains('flaunt-route-entering'); }

    syncPlayback() {
      if (!this.canPlay()) {
        this.front?.pause();
        this.stopFrameLoop();
        return;
      }
      if (this.active?.ready) this.startPlayback(this.active);
      else this.pump();
    }

    pump() {
      if (!this.canPlay()) return;
      if (this.active) {
        if (this.active.kind === 'jump') return;
        if ((this.target - this.active.to) * this.active.direction < 0) {
          const previous = this.active;
          const frame = previous.ready ? this.sourceFrame(previous, this.front.currentTime) : previous.frame;
          this.front.pause();
          this.transition(previous.to, previous.from, frame);
        }
        return;
      }
      if (this.current !== this.target) {
        const jump = this.markerTarget === this.target ? this.jumpClip(this.current, this.target) : null;
        if (jump) this.transition(this.current, this.target, undefined, jump);
        else this.transition(this.current, this.current + Math.sign(this.target - this.current));
      } else {
        if (this.markerTarget === this.current) this.markerTarget = null;
        this.preloadNext();
      }
    }

    endpoint(index) { return Number(this.states[index].end) || 1; }

    jumpClip(from, to) {
      if (Math.abs(to - from) < 2) return null;
      const first = Math.min(from, to);
      const last = Math.max(from, to);
      const key = `${first}:${last}`;
      const clip = this.variantConfig.jumps?.[key];
      if (!clip || this.failedJumpPairs.has(key) || Number(clip.from) !== first || Number(clip.to) !== last) return null;
      if (!Number.isInteger(Number(clip.frames)) || Number(clip.frames) < 2 || !(Number(clip.fps) > 0)) return null;
      if (!(to > from ? clip.forward : clip.reverse)) return null;
      return clip;
    }

    sourceFrame(active, time) {
      if (active.kind === 'jump') {
        const offset = Math.max(0, time) * active.playbackFps;
        return Math.max(0, Math.min(active.end,
          active.direction > 0 ? 1 + offset : active.end - 1 - offset));
      }
      const offset = Math.floor(Math.max(0, time) * active.playbackFps + 0.0001) * active.frameStep;
      return Math.max(active.start, Math.min(active.end,
        active.direction > 0 ? active.start + active.edgeOffset + offset : active.end - active.edgeOffset - offset));
    }

    async transition(from, to, sourceFrame, jump = null) {
      this.loadController?.abort();
      this.stopFrameLoop();
      this.front.pause();
      const serial = ++this.serial;
      const clip = jump || this.states[Math.max(from, to)];
      const direction = Math.sign(to - from);
      const active = this.active = {
        from, to, direction, serial, kind: jump ? 'jump' : 'sequential', clip,
        start: jump ? 0 : Number(clip.start), end: jump ? Number(clip.frames) - 1 : Number(clip.end),
        frame: sourceFrame ?? (jump ? (direction > 0 ? 0 : Number(clip.frames) - 1) : this.endpoint(from)), ready: false
      };
      const url = direction > 0 ? clip.forward : clip.reverse;
      const videoId = direction > 0 ? clip.forwardVideoId : clip.reverseVideoId;
      active.preview = !jump && !this.isMobileStory && ((videoId != null && Array.isArray(this.config.previewVideoIds) && this.config.previewVideoIds.map(String).includes(String(videoId)))
        || (Array.isArray(this.config.previewSources) && this.config.previewSources.includes(url)));
      active.playbackFps = jump ? Number(clip.fps) : (active.preview ? 30 : this.playbackFps);
      active.frameStep = jump ? 1 : (active.preview ? 2 : this.frameStep);
      active.edgeOffset = jump ? 1 : (active.preview ? 0 : this.edgeOffset);
      if (jump) this.players.forEach(video => { video.playbackRate = 1; });
      this.setCopy(-1);
      this.classList.remove('is-playing');
      this.classList.add('is-loading');
      if (!url) { this.finish(active, true); return; }
      const next = this.players.find(video => video !== this.front);
      const signal = (this.loadController = new AbortController()).signal;
      try {
        next.pause();
        next.muted = true;
        next.defaultMuted = true;
        next.playsInline = true;
        next.preload = 'auto';
        if (next.getAttribute('src') !== url) { next.src = url; next.load(); }
        await this.waitFor(next, 'loadedmetadata', () => next.readyState >= 1, signal);
        if (serial !== this.serial || this.active !== active) return;
        const frames = direction > 0 ? active.frame - active.start - active.edgeOffset : active.end - active.edgeOffset - active.frame;
        const seconds = frames / active.frameStep / active.playbackFps;
        const frameDuration = 1 / active.playbackFps;
        const seek = Math.max(0, Math.min(Number.isFinite(next.duration) ? next.duration - frameDuration : seconds, seconds));
        next.currentTime = seek;
        await this.waitFor(next, 'seeked', () => !next.seeking && next.readyState >= 2, signal);
        if (serial !== this.serial || this.active !== active) return;
        this.front.hidden = true;
        this.front = next;
        next.hidden = false;
        this.classList.toggle('is-preview-video', active.preview);
        if (this.poster) this.poster.hidden = true;
        active.ready = true;
        this.classList.remove('is-loading');
        if (jump) this.drawJumpFrame(active, this.sourceFrame(active, seek));
        else this.drawFrame(this.sourceFrame(active, seek));
        next.addEventListener('ended', () => this.finish(active), { once: true, signal });
        next.addEventListener('error', () => this.fail(active), { once: true, signal });
        if (this.canPlay()) this.startPlayback(active);
      } catch (error) {
        if (error.name !== 'AbortError' && serial === this.serial) this.fail(active);
      }
    }

    waitFor(video, event, ready, signal) {
      return new Promise((resolve, reject) => {
        if (signal.aborted) { reject(new DOMException('Aborted', 'AbortError')); return; }
        if (ready()) { resolve(); return; }
        const cleanup = () => {
          clearTimeout(timer);
          [event, 'loadeddata', 'canplay'].forEach(name => video.removeEventListener(name, check));
          video.removeEventListener('error', failed);
          signal.removeEventListener('abort', aborted);
        };
        const check = () => { if (ready()) { cleanup(); resolve(); } };
        const failed = () => { cleanup(); reject(new Error('Video unavailable')); };
        const aborted = () => { cleanup(); reject(new DOMException('Aborted', 'AbortError')); };
        const timer = setTimeout(failed, 15000);
        [event, 'loadeddata', 'canplay'].forEach(name => video.addEventListener(name, check));
        video.addEventListener('error', failed);
        signal.addEventListener('abort', aborted, { once: true });
      });
    }

    async startPlayback(active, userInteraction = false) {
      if (this.active !== active || !this.canPlay() || active.starting || (active.blocked && !userInteraction)) return;
      if (userInteraction && performance.now() - (active.lastAttempt || 0) < 300) return;
      active.starting = true;
      active.blocked = false;
      active.lastAttempt = performance.now();
      active.playAttempts = (active.playAttempts || 0) + 1;
      try {
        this.front.muted = true;
        this.front.playbackRate = active.kind === 'jump' || this.fastTarget === null ? 1 : 3;
        await this.front.play();
        if (this.active !== active) return;
        if (!this.canPlay()) { this.front.pause(); return; }
        active.playAttempts = 0;
        this.classList.add('is-playing');
        this.frameLoop(active);
      } catch (error) {
        if (this.active === active && this.canPlay()) {
          if (error.name === 'NotAllowedError' && active.playAttempts < 3) active.blocked = true;
          else this.fail(active);
        }
      } finally { active.starting = false; }
    }

    frameLoop(active) {
      this.stopFrameLoop();
      const video = this.front;
      const paint = (_, metadata) => {
        if (this.active !== active || !this.canPlay()) return;
        const frame = this.sourceFrame(active, metadata ? metadata.mediaTime : video.currentTime);
        active.frame = frame;
        if (active.kind === 'jump') this.drawJumpFrame(active, frame);
        else this.drawFrame(frame);
        const progress = active.direction > 0 ? (frame - active.start) / (active.end - active.start) : (active.end - frame) / (active.end - active.start);
        if (active.kind === 'jump') {
          if (this.target === active.to && progress >= 0.7) this.setCopy(active.to);
        } else if ((this.fastTarget === null || this.fastTarget === active.to) && (this.markerTarget === null || this.markerTarget === active.to) && progress >= 0.8 && (active.to !== 3 || frame >= 490)) this.setCopy(active.to);
        schedule();
      };
      const schedule = () => {
        this.frameVideo = video;
        this.frameIsVideo = typeof video.requestVideoFrameCallback === 'function';
        this.frameRequest = this.frameIsVideo ? video.requestVideoFrameCallback(paint) : requestAnimationFrame(paint);
      };
      schedule();
    }

    stopFrameLoop() {
      if (this.frameRequest !== undefined) {
        if (this.frameIsVideo) this.frameVideo?.cancelVideoFrameCallback(this.frameRequest);
        else cancelAnimationFrame(this.frameRequest);
      }
      this.frameRequest = undefined;
    }

    finish(active, usePoster = false) {
      if (this.active !== active) return;
      this.front.pause();
      this.stopFrameLoop();
      this.active = null;
      this.classList.remove('is-playing', 'is-loading');
      if (this.fastTarget === active.to) this.setFastTarget(null);
      if (this.markerTarget === active.to) this.markerTarget = null;
      this.showState(active.to, usePoster);
      this.pump();
    }

    fail(active) {
      if (this.active !== active) return;
      if (active.kind === 'jump') {
        this.failedJumpPairs.add(`${Math.min(active.from, active.to)}:${Math.max(active.from, active.to)}`);
        if (!active.ready) {
          this.loadController?.abort();
          this.active = null;
          this.classList.remove('is-playing', 'is-loading');
          this.showState(active.from, false);
          this.pump();
          return;
        }
      }
      this.finish(active, true);
      if (!this.active && this.current === active.to) {
        if (this.status) this.status.textContent = this.config.strings?.playbackFallback || '';
      }
    }

    highlightChapter(index) {
      this.querySelectorAll('[data-go]').forEach(button => {
        if (Number(button.dataset.go) === index) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
      });
    }

    showState(index, usePoster) {
      this.current = index;
      this.dataset.state = index;
      this.drawFrame(this.endpoint(index));
      this.setCopy((this.fastTarget === null || this.fastTarget === index) && (this.markerTarget === null || this.markerTarget === index) ? index : -1);
      this.highlightChapter(this.target);
      if (this.status) this.status.textContent = '';
      if (usePoster && this.poster && this.states[index].poster) {
        const image = new Image();
        const controller = this.controller;
        const variant = this.variantConfig;
        const serial = this.serial;
        const show = () => {
          if (!this.controller || this.controller !== controller || this.variantConfig !== variant || this.serial !== serial || this.current !== index || this.active) return;
          this.poster.src = image.src;
          this.poster.hidden = false;
          this.players.forEach(video => { video.hidden = true; });
          this.classList.remove('is-preview-video');
        };
        image.onload = show;
        image.src = this.states[index].poster;
        if (image.complete && image.naturalWidth) show();
      }
    }

    setCopy(index) {
      if (this.copyIndex === index) return;
      this.copyIndex = index;
      this.querySelectorAll('[data-copy]').forEach(panel => {
        const shown = Number(panel.dataset.copy) === index;
        panel.hidden = false;
        panel.inert = !shown;
        panel.classList.toggle('is-active', shown);
        panel.setAttribute('aria-hidden', String(!shown));
      });
    }

    drawJumpFrame(active, frame) {
      this.styleLabels.forEach(label => { label.hidden = true; label.style.opacity = '0'; });
      if (!this.logo) return;
      const frames = active.clip.logoFrames || [];
      const position = Math.max(0, Math.min(active.end, frame));
      const first = Math.floor(position);
      const last = Math.min(active.end, first + 1);
      const before = frames[first];
      const after = frames[last] || before;
      if (!before || !after) { this.logo.style.opacity = '0'; this.style.setProperty('--fss-logo-opacity', 0); return; }
      const amount = position - first;
      const bounds = before.map((value, index) => Number(value) + (Number(after[index]) - Number(value)) * amount);
      ['left', 'top', 'width', 'height'].forEach((property, index) => { this.logo.style[property] = `${bounds[index] * 100}%`; });
      this.logo.style.opacity = String(bounds[4]);
      this.style.setProperty('--fss-logo-opacity', bounds[4]);
    }

    drawFrame(frame) {
      const labels = this.isMobileStory ? this.variantConfig.styleLabels || [] : [];
      this.styleLabels.forEach((label, index) => {
        const name = label.dataset.mobileStyleLabel?.toLowerCase();
        const settings = name ? labels.find(item => String(item.name).toLowerCase() === name) : labels[index];
        label.hidden = !settings;
        if (!settings) { label.style.opacity = '0'; return; }
        const ramp = (start, end) => end > start ? Math.max(0, Math.min(1, (frame - start) / (end - start))) : Number(frame >= end);
        const opacity = ramp(Number(settings.fadeInStart), Number(settings.arrival)) * (1 - ramp(Number(settings.fadeOutStart), Number(settings.fadeOutEnd)));
        label.style.left = `${Number(settings.centerX) * 100}%`;
        label.style.top = `${Number(settings.top) * 100}%`;
        label.style.opacity = String(opacity);
      });
      if (!this.logo) return;
      const bounds = this.variantConfig.logoFrames?.[Math.max(0, Math.round(frame) - 1)];
      if (!bounds) { this.logo.style.opacity = '0'; this.style.setProperty('--fss-logo-opacity', 0); return; }
      ['left', 'top', 'width', 'height'].forEach((property, index) => { this.logo.style[property] = `${bounds[index] * 100}%`; });
      this.logo.style.opacity = String(bounds[4]);
      this.style.setProperty('--fss-logo-opacity', bounds[4]);
    }

    preloadNext() {
      if (!this.canPlay()) return;
      const next = this.players.find(video => video !== this.front);
      const url = this.states[this.current + 1]?.forward;
      if (!url || next.getAttribute('src') === url) return;
      next.pause();
      next.preload = 'metadata';
      next.src = url;
      next.load();
    }
  }

  customElements.define('flaunt-scroll-story', FlauntScrollStory);
})();

(() => {
  if (customElements.get('flaunt-signup')) return;
  customElements.define('flaunt-signup', class extends HTMLElement {
    connectedCallback() {
      const feedback = this.querySelector('[data-fss-signup-feedback]');
      if (!feedback) return;
      this.feedbackFrame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.querySelector('.fss-signup__section')?.scrollIntoView({ behavior: 'instant', block: 'start' });
        feedback.focus({ preventScroll: true });
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.feedbackFrame);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
